/**
 * @description
 * 使用以下规则顺序:
 * 通用 拼多多 淘系(淘宝，阿里巴巴，淘工厂，天猫) 抖店 快手  京东
 *
 */
enum OrderTag {
    /** ------------通用标签----------- */
    /**顺丰包邮 */
    FREE_SF = "FREE_SF",
    /** 买家自提 */
    SELF_CONTAINED = "SELF_CONTAINED",
    /** 催发货 */
    EXPEDITE_DELIVERY = "EXPEDITE_DELIVERY",
    /**
     * 集运
     * 理论上拼多多可能会有，例如平台新增了某些地区集运但是又还没对接转换的话就会转换成这个标签
     */
    CONSOLIDATED_SHIPPING = "CONSOLIDATED_SHIPPING",
    /**推迟发货 */
    SHIPPING_DELAY = "SHIPPING_DELAY",
    /** 手动锁单 */
    LOCKED = "LOCKED",
    /** 预售 */
    PRESALE = "PRESALE",
    /** 部分数量取消 */
    ORDER_ITEM_PART_QUANTITY_CANCELED = "ORDER_ITEM_PART_QUANTITY_CANCELED",
    /** 部分数量发货 */
    ORDER_ITEM_PART_QUANTITY_SHIPPED = "ORDER_ITEM_PART_QUANTITY_SHIPPED",
    /** 异常订单 */
    ABNORMAL_ORDER = "ABNORMAL_ORDER",
    /** 黑名单 */
    BUYER_BLACKLIST = "BUYER_BLACKLIST",
    /** 样品 */
    SAMPLE = "SAMPLE",
    /** 指定物流 */
    DESIGNATED_LOGISTICS = "DESIGNATED_LOGISTICS",
    /**
     * 全款预售
     */
    FULL_PAYMENT_PRESALE = "FULL_PAYMENT_PRESALE",
    /** 回收运单号 */
    CANCEL_WAYBILL_RECYCLED = "CANCEL_WAYBILL_RECYCLED",
    /** 周期购 */
    PERIOD_PURCHASE = "PERIOD_PURCHASE",
    /** 礼物单 */
    PRESENT = "PRESENT",
    /** 国补供销 */
    SUBSIDY_SUPPLY_SALE = "SUBSIDY_SUPPLY_SALE",
    /** 国补字销 */
    SUBSIDY_SELF_SALE = "SUBSIDY_SELF_SALE",
    /** 国补3C */
    SUBSIDY_3C = "SUBSIDY_3C",
    /** 国补大家电 */
    SUBSIDY_MAJOR_APPLIANCE = "SUBSIDY_MAJOR_APPLIANCE",
    /** 发货易定制订单 */
    LH_CUSTOMIZATION = "LH_CUSTOMIZATION",
    GREETING_CARD = "GREETING_CARD",
    /** 组合品部分发货  */
    ORDER_ITEM_PART_BUNDLE_SKU_SHIPPED = "ORDER_ITEM_PART_BUNDLE_SKU_SHIPPED",
    /** 有售后 */
    SHIPPED_OR_SUCCESS_ITEM_WITH_AFTERSALE = "SHIPPED_OR_SUCCESS_ITEM_WITH_AFTERSALE",
    /** 不打烊 */
    OPEN_IN_FESTIVAL = "OPEN_IN_FESTIVAL",
    /** 不能发货 */
    CANNOT_SHIP = "CANNOT_SHIP",
    /** 抖店极速发货成功 */
    INSTANT_SHIP = "INSTANT_SHIP",
    /**
     * 通用-加价发顺丰
     */
    SHIP_BY_SF = "SHIP_BY_SF",
    /**
     * 通用-加价发顺丰标快
     */
    SHIP_BY_SF_EXPRESS = "SHIP_BY_SF_EXPRESS",
    /**
     * 通用-加价发顺丰特快
     */
    SHIP_BY_SF_EXPRESS_TK = "SHIP_BY_SF_EXPRESS_TK",
    /**
     * 质检
     */
    QUALITY_INSPECTION = "QUALITY_INSPECTION",
    /** ------------拼多多标签----------- */
    /**
     * @deprecated
     * 拼多多加运费发顺丰(后端已转化成SHIP_BY_SF)
     */
    PDD_SHIP_BY_SF = "PDD_SHIP_BY_SF",
    /** 暂停发货 */
    SHIP_HOLD = "SHIP_HOLD",
    /** 指定包材 */
    PDD_DESIGNATED_PACKAGE_MATERIAL = "PDD_DESIGNATED_PACKAGE_MATERIAL",
    /**拼多多发货时间可延迟 */
    PDD_REGION_BLACK_DELAY_SHIPPING = "PDD_REGION_BLACK_DELAY_SHIPPING",
    /** 拼多多当日发货 */
    PDD_DELIVERY_ONE_DAY = "PDD_DELIVERY_ONE_DAY",
    /** 拼多多无痕发货 */
    PDD_NO_TRACE_DELIVERY = "PDD_NO_TRACE_DELIVERY",
    /** 小区团购 */
    PDD_COMMUNITY_GROUP = "PDD_COMMUNITY_GROUP",
    /** 过敏包退 */
    PDD_ALLERGY_REFUND = "PDD_ALLERGY_REFUND",
    /** 拼多多新疆中转 */
    PDD_XINJIANG_CONSOLIDATE = "PDD_XINJIANG_CONSOLIDATE",
    /** 拼多多香港集运 */
    PDD_HK_CONSOLIDATE = "PDD_HK_CONSOLIDATE",
    /** 拼多多澳门集运 */
    PDD_MACAO_CONSOLIDATE = "PDD_MACAO_CONSOLIDATE",
    /** 拼多多哈萨克斯坦中转 */
    PDD_KAZAKHSTAN_CONSOLIDATE = "PDD_KAZAKHSTAN_CONSOLIDATE",
    /** 拼多多西藏中转 */
    PDD_XIZANG_CONSOLIDATE = "PDD_XIZANG_CONSOLIDATE",
    /** 拼多多日本集运 */
    PDD_JAPAN_CONSOLIDATE = "PDD_JAPAN_CONSOLIDATE",
    /** 拼多多中国台湾集运 */
    PDD_TAIWAN_CONSOLIDATE = "PDD_TAIWAN_CONSOLIDATE",
    /** 拼多多韩国集运 */
    PDD_KOREA_CONSOLIDATE = "PDD_KOREA_CONSOLIDATE",
    /** 拼多多新加坡集运 */
    PDD_SINGAPORE_CONSOLIDATE = "PDD_SINGAPORE_CONSOLIDATE",
    /** 拼多多马来西亚集运 */
    PDD_MALAYSIA_CONSOLIDATE = "PDD_MALAYSIA_CONSOLIDATE",
    /** 拼多多泰国集运 */
    PDD_THAILAND_CONSOLIDATE = "PDD_THAILAND_CONSOLIDATE",
    /** 拼多多越南集运 */
    PDD_VIETNAM_CONSOLIDATE = "PDD_VIETNAM_CONSOLIDATE",
    /** 拼多多吉尔吉斯斯坦集运 */
    PDD_KYRGYZSTAN_CONSOLIDATE = "PDD_KYRGYZSTAN_CONSOLIDATE",
    /** 拼多多乌兹别克斯坦集运 */
    PDD_UZBEKISTAN_CONSOLIDATE = "PDD_UZBEKISTAN_CONSOLIDATE",
    /** 拼多多甘肃集运 */
    PDD_GANSU_CONSOLIDATE = "PDD_GANSU_CONSOLIDATE",
    /** 拼多多内蒙古集运 */
    PDD_NEIMENGGU_CONSOLIDATE = "PDD_NEIMENGGU_CONSOLIDATE",
    /** 拼多多宁夏集运 */
    PDD_NINGXIA_CONSOLIDATE = "PDD_NINGXIA_CONSOLIDATE",
    /** 拼多多青海集运 */
    PDD_QINGHAI_CONSOLIDATE = "PDD_QINGHAI_CONSOLIDATE",
    /** 拼多多快递上门揽收 */
    PDD_COURIER_DOOR_TO_DOOR_COLLECT = "PDD_COURIER_DOOR_TO_DOOR_COLLECT",
    /** 拼多多预约配送  */
    PDD_DELIVERY_APPOINTMENT = "PDD_DELIVERY_APPOINTMENT",
    /** 拼多多送货上门 */
    PDD_HOME_DELIVERY = "PDD_HOME_DELIVERY",
    /** 拼多多直邮活动 */
    PDD_DIRECT_MAIL_ACTIVITY = "PDD_DIRECT_MAIL_ACTIVITY",
    /** 承诺送达 */
    PDD_PROMISE_ARRIVAL = "PDD_PROMISE_ARRIVAL",
    /** 微派服务 */
    PDD_WEIPAI_SERVICE = "PDD_WEIPAI_SERVICE",
    /** 拼多多共享仓 */
    PDD_FULFILLMENT_BY_SHARED_WAREHOUSE = "PDD_FULFILLMENT_BY_SHARED_WAREHOUSE",
    /** ------------淘宝标签----------- */
    /** 淘宝标签 */
    /** 家装 */
    TB_DECORATION_ORDER = "TB_DECORATION_ORDER",
    /**淘宝小额收款订单 */
    TB_PETTY_FEE_RECEIPT = "TB_PETTY_FEE_RECEIPT",
    /**
     * @deprecated
     * 淘宝不能发货
     */
    TAOTIAN_PAID_FORBIN_CONSIGN = "TAOTIAN_PAID_FORBIN_CONSIGN",
    /** 淘宝新疆集运 */
    TAOTIAN_XINJIANG_CONSOLIDATE = "TAOTIAN_XINJIANG_CONSOLIDATE",
    /**
     * @deprecated
     * 加价发顺丰(后端已转化成SHIP_BY_SF)
     */
    TAOTIAN_SHIP_BY_SF = "TAOTIAN_SHIP_BY_SF",
    /** 淘宝集运 */
    TAOTIAN_CONSOLIDATED_SHIPPING = "TAOTIAN_CONSOLIDATED_SHIPPING",
    /** 红包 */
    LUCKY_MONEY = "LUCKY_MONEY",
    /** 补发单 */
    TAOTIAN_REISSUE = "TAOTIAN_REISSUE",
    /** 闲鱼 */
    TAOTIAN_GOOFISH = "TAOTIAN_GOOFISH",
    /** 闪购-平台配送 */
    TAOTIAN_INSTANT_RETAIL_PLATFORM_DELIVERY = "TAOTIAN_INSTANT_RETAIL_PLATFORM_DELIVERY",
    /** 闪购-商家配送 */
    TAOTIAN_INSTANT_RETAIL_SELLER_DELIVERY = "TAOTIAN_INSTANT_RETAIL_SELLER_DELIVERY",
    /** 超链订单 */
    TAOTIAN_SUPER_LINK_ORDER = "TAOTIAN_SUPER_LINK_ORDER",
    /** 官方鉴别 */
    TAOTIAN_OFFICIAL_IDENTIFICATION = "TAOTIAN_OFFICIAL_IDENTIFICATION",
    /** 淘宝天猫加价发顺丰集采 */
    TAOTIAN_SHIP_BY_SF_JC = "TAOTIAN_SHIP_BY_SF_JC",
    /** 加急发货  */
    TAOTIAN_URGENT_DELIVERY = "TAOTIAN_URGENT_DELIVERY",
    /** ------------阿里标签----------- */
    /** 阿里 发货即将超时 */
    ALI_SEND_ABOUT_TO_OVERDUE = "ALI_SEND_ABOUT_TO_OVERDUE",
    /* 阿里 发货已超时 */
    ALI_SEND_OVERDUE = "ALI_SEND_OVERDUE",
    /* 阿里 揽收已超时 */
    ALI_DELIVER_OVERDUE = "ALI_DELIVER_OVERDUE",
    /** 1688官方直送 */
    ALI_DELIVERY_GUARANTEE = "ALI_DELIVERY_GUARANTEE",
    /** 淘宝\天猫\淘特加密分销订单 */
    ALI_OUT_ORDER_TAOBAO = "ALI_OUT_ORDER_TAOBAO",
    /** 拼多多加密分销 */
    ALI_OUT_ORDER_PDD = "ALI_OUT_ORDER_PDD",
    /** 抖音加密分销 */
    ALI_OUT_ORDER_DY = "ALI_OUT_ORDER_DY",
    /** 快手加密分销 */
    ALI_OUT_ORDER_KWAI = "ALI_OUT_ORDER_KWAI",
    /** 小红书加密分销 */
    ALI_OUT_ORDER_XHS = "ALI_OUT_ORDER_XHS",
    /** 京东加密分销 */
    ALI_OUT_ORDER_JD = "ALI_OUT_ORDER_JD",
    /** 微信小店加密分销 */
    ALI_OUT_ORDER_WEIXIN = "ALI_OUT_ORDER_WEIXIN",

    /** 淘宝\天猫\淘特明文分销订单 */
    ALI_PLAINTEXT_OUT_ORDER_TAOBAO = "ALI_PLAINTEXT_OUT_ORDER_TAOBAO",
    /** 拼多多明文分销 */
    ALI_PLAINTEXT_OUT_ORDER_PDD = "ALI_PLAINTEXT_OUT_ORDER_PDD",
    /** 抖音明文分销 */
    ALI_PLAINTEXT_OUT_ORDER_DY = "ALI_PLAINTEXT_OUT_ORDER_DY",
    /** 快手明文分销 */
    ALI_PLAINTEXT_OUT_ORDER_KWAI = "ALI_PLAINTEXT_OUT_ORDER_KWAI",
    /** 小红书明文分销 */
    ALI_PLAINTEXT_OUT_ORDER_XHS = "ALI_PLAINTEXT_OUT_ORDER_XHS",
    /** 京东明文分销 */
    ALI_PLAINTEXT_OUT_ORDER_JD = "ALI_PLAINTEXT_OUT_ORDER_JD",

    /**
     * @deprecated
     * 不可发货
     */
    ALI_CAN_NOT_SHIP = "ALI_CAN_NOT_SHIP",
    /** 定制服务 */
    ALI_CUSTOMIZATION = "ALI_CUSTOMIZATION",
    /** 跨境订单 */
    ALI_CROSS_BORDER = "ALI_CROSS_BORDER",
    /** 托管订单 */
    ALI_MANAGED_SHIPPING = "ALI_MANAGED_SHIPPING",
    /** 速卖通上门揽订单 */
    ALI_AE_DOOR_PICKUP = "ALI_AE_DOOR_PICKUP",
    /** 速卖通自寄订单 */
    ALI_AE_SELF_SEND = "ALI_AE_SELF_SEND",
    /** 云仓代发 */
    ALI_FULFILLMENT_BY_WAREHOUSE = "ALI_FULFILLMENT_BY_WAREHOUSE",
    /** ------------淘工厂标签----------- */
    /** 补寄工单 */
    ALI_C2M_RESHIPMENT = "ALI_C2M_RESHIPMENT",
    /** ------------天猫标签----------- */
    /** 送货上门 */
    TMALL_HOME_DELIVERY = "TMALL_HOME_DELIVERY",
    /** 天猫物流升级 */
    TMALL_LOGISTICS_UPGRADE = "TMALL_LOGISTICS_UPGRADE",
    /** 天猫物流升级：按需配送 */
    TMALL_LOGISTICS_SHIP_AS_REQUIRED = "TMALL_LOGISTICS_SHIP_AS_REQUIRED",
    /** 天猫物流升级：顺丰配送 */
    TMALL_LOGISTICS_SHIP_BY_SF = "TMALL_LOGISTICS_SHIP_BY_SF",
    /** 天猫物流升级：承诺发货 */
    TMALL_LOGISTICS_PROMISE_SHIPPING = "TMALL_LOGISTICS_PROMISE_SHIPPING",
    /** 天猫物流升级：承诺送到 */
    TMALL_LOGISTICS_PROMISE_SERVED = "TMALL_LOGISTICS_PROMISE_SERVED",
    /** ------------抖店标签----------- */
    /** 送货上门 */
    DOUDIAN_HOME_DELIVERY = "DOUDIAN_HOME_DELIVERY",
    /** 推荐送货上门 */
    DOUDIAN_HOME_DELIVERY_RECOMMENDED = "DOUDIAN_HOME_DELIVERY_RECOMMENDED",
    /**
     * @deprecated
     * 抖店顺丰包邮(后端已转化成SHIP_BY_SF)
     */
    DOUDIAN_SHIP_BY_SF = "DOUDIAN_SHIP_BY_SF",
    /** 抖店优先发货 */
    DOUDIAN_PRIORITY_DELIVERY = "DOUDIAN_PRIORITY_DELIVERY",
    /** 赠品后发 */
    DOUDIAN_GIFT_LATE_DELIVERY = "DOUDIAN_GIFT_LATE_DELIVERY",

    /**
     * 抖音双地址
     * 暂时抖店才有，后续如果有调整需要改动src/scenes/OrderManagement/components/OrderTable/SearchPane/OrderTagSelectField.tsx
     *
     * */
    DOUBLE_ADDRESS = "DOUBLE_ADDRESS",
    /**
     * 骗地址双地址 （前端实现）
     **/
    LOCAL_DOUBLE_ADDRESS = "LOCAL_DOUBLE_ADDRESS",
    /**
     * 抖店新疆中转
     */
    DOUDIAN_CONSOLIDATION_XINJIANG = "DOUDIAN_CONSOLIDATION_XINJIANG",

    /**
     * 预约发货 页面不再提供搜索，转为成DOUDIAN_APPOINTMENT_DELIVERY进行搜索
     */
    DOUDIAN_DELIVERY_APPOINTMENT = "DOUDIAN_DELIVERY_APPOINTMENT",

    /**
     * 承诺日达
     * 页面不再提供搜索，转为成DOUDIAN_APPOINTMENT_ARRIVAL_V2进行搜索
     */
    DOUDIAN_APPOINTMENT_ARRIVAL = "DOUDIAN_APPOINTMENT_ARRIVAL",

    /** 预约发货2.0  */
    DOUDIAN_APPOINTMENT_DELIVERY = "DOUDIAN_APPOINTMENT_DELIVERY",
    /** 预约送达 */
    DOUDIAN_APPOINTMENT_ARRIVAL_V2 = "DOUDIAN_APPOINTMENT_ARRIVAL_V2",
    /** 承诺送达  */
    DOUDIAN_PROMISE_ARRIVAL = "DOUDIAN_PROMISE_ARRIVAL",
    /** 偏远直邮 */
    DOUDIAN_REMOTE_DIRECT = "DOUDIAN_REMOTE_DIRECT",
    /** 抖店西藏中转 */
    DOUDIAN_CONSOLIDATION_XIZANG = "DOUDIAN_CONSOLIDATION_XIZANG",
    /** 供应链订单 */
    DOUDIAN_ORDER_SUPPLY = "DOUDIAN_ORDER_SUPPLY",
    /** 合包发货 */
    DOUDIAN_CONSOLIDATION_MERGE = "DOUDIAN_CONSOLIDATION_MERGE",
    /**
     * @deprecated
     * 加价发顺丰(后端已转化成SHIP_BY_SF_EXPRESS)
     */
    DOUDIAN_PAID_SF_EXPRESS = "DOUDIAN_PAID_SF_EXPRESS",
    /**
     * @deprecated
     * 发顺丰特快(后端已转化成SHIP_BY_SF_EXPRESS_TK)
     */
    DOUDIAN_PAID_SF_EXPRESS_TK = "DOUDIAN_PAID_SF_EXPRESS_TK",
    /** 优质快递 */
    DOUDIAN_HIGH_QUALITY_EXPRESS = "DOUDIAN_HIGH_QUALITY_EXPRESS",
    /** 高频购买 */
    DOUDIAN_BUY_FREQUENCY = "DOUDIAN_BUY_FREQUENCY",
    /** 服务优先 */
    DOUDIAN_PRIORITY_SERVICE = "DOUDIAN_PRIORITY_SERVICE",
    /** 店铺老客 */
    DOUDIAN_SHOP_REGULAR_CUSTOMER = "DOUDIAN_SHOP_REGULAR_CUSTOMER",
    /** 明日达 */
    DOUDIAN_TOMORROW_RECEIPT = "DOUDIAN_TOMORROW_RECEIPT",
    /** 商家安装 */
    DOUDIAN_SHOP_INSTALLATION = "DOUDIAN_SHOP_INSTALLATION",
    /** 春节延迟发货 */
    DOUDIAN_SPRING_FESTIVAL_DELAY_SHIPPING = "DOUDIAN_SPRING_FESTIVAL_DELAY_SHIPPING",
    /** ------------快手标签----------- */
    /**
     * @deprecated
     * 快手顺丰包邮(后端已转化成SHIP_BY_SF)
     */
    KWAI_SHIP_BY_SF = "KWAI_SHIP_BY_SF",
    /** 快手优先发货 */
    KWAI_PRIORITY_DELIVERY = "KWAI_PRIORITY_DELIVERY",
    /** 推荐顺丰 */
    KWAI_SHIP_BY_SF_RECOMMEND = "KWAI_SHIP_BY_SF_RECOMMEND",
    /** 新疆中转 */
    KWAI_CONSOLIDATION_XINJIANG = "KWAI_CONSOLIDATION_XINJIANG",
    /** 内蒙古中转 */
    KWAI_CONSOLIDATION_NEIMENGGU = "KWAI_CONSOLIDATION_NEIMENGGU",
    /** 青海中转 */
    KWAI_CONSOLIDATION_QINGHAI = "KWAI_CONSOLIDATION_QINGHAI",
    /** 甘肃中转 */
    KWAI_CONSOLIDATION_GANSU = "KWAI_CONSOLIDATION_GANSU",
    /** 宁夏中转 */
    KWAI_CONSOLIDATION_NINGXIA = "KWAI_CONSOLIDATION_NINGXIA",
    /** 西藏中转 */
    KWAI_CONSOLIDATION_XIZANG = "KWAI_CONSOLIDATION_XIZANG",
    /** 明日达 */
    KWAI_TOMORROW_ARRIVAL = "KWAI_TOMORROW_ARRIVAL",
    /** 隔日达 */
    KWAI_NEXT_DAY_ARRIVAL = "KWAI_NEXT_DAY_ARRIVAL",
    /** 24小时揽 */
    KWAI_PICK_UP_IN24H = "KWAI_PICK_UP_IN24H",
    /** ------------京东标签----------- */
    /** 先用后付 */
    JD_TRY_BEFORE_PAY_LATER = "JD_TRY_BEFORE_PAY_LATER",
    /** 京仓订单 */
    JD_FULFILLMENT = "JD_FULFILLMENT",
    /** 京配 */
    JD_DELIVERY = "JD_DELIVERY",
    /** 配货清单 */
    JD_PACKING_LIST_REQUIRED = "JD_PACKING_LIST_REQUIRED",
    /** 大件送货上门 */
    JD_HOME_DELIVERY_BULKY = "JD_HOME_DELIVERY_BULKY",
    /** 送货上门(中小件送货上门) */
    JD_HOME_DELIVERY_LIGHT = "JD_HOME_DELIVERY_LIGHT",

    JD_ENCRYPTED_OUT_ORDER_DOUDIAN = "JD_ENCRYPTED_OUT_ORDER_DOUDIAN",

    JD_ENCRYPTED_OUT_ORDER_KWAI = "JD_ENCRYPTED_OUT_ORDER_KWAI",

    /** 新疆集运 */
    JD_CONSOLIDATION_XINJIANG = "JD_CONSOLIDATION_XINJIANG",

    /** 预约发货 */
    JD_DELIVERY_APPOINTMENT = "JD_DELIVERY_APPOINTMENT",

    /** 京东供销 */
    JD_PURCHASE = "JD_PURCHASE",

    /** 超链订单 */
    JD_HYPERLINK_ORDER = "JD_HYPERLINK_ORDER",
    /** 超链国补 */
    JD_HYPERLINK_SUBSIDY_ORDER = "JD_HYPERLINK_SUBSIDY_ORDER",
    /** 安心宠 */
    JD_PET_ITEM = "JD_PET_ITEM",

    /** 微信小店标签 */
    /** 送检订单 */
    CHANNELSHOP_QUALITY_INSPECTION = "CHANNELSHOP_QUALITY_INSPECTION",

    /** 小红书标签 */
    XHS_HOME_DELIVERY = "XHS_HOME_DELIVERY",

    /** ------------鲸灵标签----------- */
    /** 微信小店加密分销 */
    JL_OUT_ORDER_CHANNELSHOP = "JL_OUT_ORDER_CHANNELSHOP",

    /** ------------手工店铺标签----------- */
    ENCRYPTED_MANUAL_ORDER_DOUDIAN = "ENCRYPTED_MANUAL_ORDER_DOUDIAN",

    ENCRYPTED_MANUAL_ORDER_TAOBAO = "ENCRYPTED_MANUAL_ORDER_TAOBAO",

    ENCRYPTED_MANUAL_ORDER_PDD = "ENCRYPTED_MANUAL_ORDER_PDD",

    ENCRYPTED_MANUAL_ORDER_KWAI = "ENCRYPTED_MANUAL_ORDER_KWAI",

    ENCRYPTED_MANUAL_ORDER_JD = "ENCRYPTED_MANUAL_ORDER_JD",

    ENCRYPTED_MANUAL_ORDER_XHS = "ENCRYPTED_MANUAL_ORDER_XHS",
}

export default OrderTag;
